import { scrollToActiveElementOnMount, isLocalViewer, isBranch } from '..';
import { isLinkExistInDocs } from '../../../Store/Utils/treeUtils';

export const changeHashValuesToBePartOfTheUrl = (history, fullTree) => {
  if (
    history.location.hash &&
    !isLocalViewer(history.location) &&
    !isBranch(history.location)
  ) {
    const pathPart = history.location.pathname.slice(1);
    const hashPart = history.location.hash.toLowerCase().slice(1);
    const link = `/${pathPart}/${hashPart}`;
    if (isLinkExistInDocs(fullTree, link)) {
      console.log('Replacing hash to full url');
      history.replace({
        pathname: link,
        search: history.location.search,
      });
      scrollToActiveElementOnMount(history.location);
    } else if (!hashPart.includes('_')) {
      history.replace({
        pathname: history.location.pathname,
        search: '',
      });
      scrollToActiveElementOnMount(history.location);
    }
  }
};
